export function downloadExcel(data = [], columns = [], type,name) {
  // 参数1 放数据源  参数2 放配置项 参数三特殊情况处理
  let table = "";
  let thtd = "";
  let tbody = "";
  columns.forEach(res => {
    thtd += ` <td>${res.label}</td>\n`;
  });
  table = `<thead>\n${thtd}</thead>\n`;
  data.forEach((item, index) => {
    let tdls = "";
    if (type == "special") {
      columns.forEach(res => {
        tdls += ` <td>${
          String(item[res.prop]) == "0" ? "0" : item[res.prop] || index
        }</td>\n`;
      });
    } else {
      columns.forEach(res => {
        tdls += ` <td>${
          String(item[res.prop]) == "0" ? "0" : item[res.prop] || index + 1
        }</td>\n`;
      });
    }
    tbody += `<tr>\n${tdls}   </tr>\n`;
  });
  table += `<tbody>\n${tbody}</tbody>`;
  const html = `
     <html>
      <!DOCTYPE html>
      <head>
        <meta charset="utf-8">
    <style>
     body{
    border: 0.5px solid;
     }
    tbody{
     text-align: center;
    }
    td{
    height: 24px;
   width: 120px;
   }
     </style>
    </head>
     <body>
     <table border="1">
     ${table}
     </table>
     </body>
     </html>`;
  const blob = new Blob([html], { type: "application/vnd.ms-excel" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  
  a.setAttribute("download", `${name?name:'表格'}.xls`);
  if (type == "url") {
    return blob;
  }
  a.click();
}
